/**
 * Job filter form: drop empty selects so URLs stay clean (?category=6).
 */
export function initCareers() {
	const form = document.querySelector( '.archive__filter' );
	if ( ! form ) {
		return;
	}
	form.addEventListener( 'submit', () => {
		form.querySelectorAll( 'select, input' ).forEach( ( field ) => {
			if ( ! field.value ) {
				field.disabled = true;
			}
		} );
	} );
	// Re-enable after bfcache restore (back button).
	window.addEventListener( 'pageshow', () => form.querySelectorAll( '[disabled]' ).forEach( ( f ) => ( f.disabled = false ) ) );
}
